import React from "react";
import TooltipWrapper from "./TooltipWrapper";

export default function EllipsisText({
  children = "",
  charLimit = 40,
  className = "",
  cursor = "cursor-default",
  tooltipClasses = "",
  tooltipContentClasses = "",
}) {
  const text = typeof children === "string" ? children : String(children);
  const isTruncated = text.length > charLimit;
  const displayText = isTruncated ? `${text.slice(0, charLimit)}...` : text;

  return (
    <TooltipWrapper
      content={isTruncated ? text : ""}
      cursor={cursor}
      className={tooltipClasses}
      contentClassName={tooltipContentClasses}
    >
      <span className={`whitespace-nowrap text-ellipsis overflow-hidden ${className}`}>{displayText}</span>
    </TooltipWrapper>
  );
}
